import { render, staticRenderFns } from "./ProcessPreview.vue?vue&type=template&id=04872a7d&scoped=true"
import script from "./ProcessPreview.vue?vue&type=script&lang=js"
export * from "./ProcessPreview.vue?vue&type=script&lang=js"
import style0 from "./ProcessPreview.vue?vue&type=style&index=0&id=04872a7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04872a7d",
  null
  
)

export default component.exports